<template lang="pug">
  .ajax-radio
    span.radio-wrap(v-if="option")
      input.is-checkradio(type="radio" :id="`def_checkbox${_uid}`" v-model="chosenRadio" :value="-1")
      label.checkbox(:for="`def_checkbox${_uid}`") {{ option }}
    span.radio-wrap(v-for="(item, index) in items")
      input.is-checkradio(type="radio" :id="`radio_${item.name}_${index}${name}`" v-model="chosenRadio" :value="item")
      label.checkbox(:for="`radio_${item.name}_${index}${name}`") {{ item.name }}
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
const _ = require('lodash')

export default {
  name: 'AjaxRadio',
  components: {
  },
  data () {
    return {
      chosenRadio: -1
    }
  },
  props: {
    items: {
      default: () => {
        return []
      }
    },
    value: {
      default: ''
    },
    name: {
      default: ''
    },
    option: {
      default: ''
    }
  },
  methods: {
    gettext: gettext,
    syncData () {
      this.chosenRadio = _.find(this.items, {id: this.chosenRadio.id}) || this.chosenRadio
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    chosenRadio: function (val) {
      this.$emit('input', (val))
    },
    value: function (val) {
      if ((typeof val === 'string') && this.items.length) {
        this.chosenRadio = _.find(this.items, {'id': parseInt(val)})
      }
      if (typeof val === 'object') {
        if (!Object.keys(val).length) {
          this.chosenRadio = -1
        }
      }
    },
    items () {
      this.syncData()
    }
  },
  created () {
    console.log(this.items)
  }
}
</script>

<style lang='scss'>
    .accordion {
    .accordion-body {
      padding: 0 15px 10px 15px!important;
    }
    .accordion-content {
      .ajax-radio{
        display: flex;
        flex-direction: column;
        .radio-wrap{
          padding-bottom: 5px;
        }
      }
      .is-checkradio[type=radio] {
        &:hover:not([disabled]) + label:before {
          border-color: #bb1d2c !important;
        }
        &:checked + label::after, .is-checkradio[type=radio]:checked + label:after {
          background: #bb1d2c !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ajax-radio/index.vue